import React from 'react';
import { List, OrderedMap } from 'immutable';
import { Node } from '@uncinc/react-drupal-core';
import Container from '../../../components/Container';
import Select from '../../../components/Select';
import i18next from '../../../config/i18next';

import './style.scss';

const Department = ({ id, entity }) => {
  return (
    <div className="mb-6" id={`department-${id}`}>
      <h2>{entity.getIn(['name', 0, 'value'], '')}</h2>
      <p>{entity.getIn(['description', 0, 'value'], '')}</p>
    </div>
  );
};

const EmployeesAll = (props) => {
  const { entities } = props;

  let employees = OrderedMap();
  let departments = OrderedMap();
  const departmentsJumplist = [];
  entities.map((entity) => {
    const departmentId = entity.getIn(['field_department', 0, 'target_id']);
    const department = entity.getIn(['field_department', 0, 'entity']);

    if (department && !departments.get(departmentId)) {
      departments = departments.set(departmentId, department);
      departmentsJumplist.push({
        value: `department-${departmentId}`,
        label: department.getIn(['name', 0, 'value']),
      });
    }
    employees = employees.update(departmentId, List(), (departmentsNew) => departmentsNew.push(entity));
  });

  return (
    <div className="View EmployeesAll">
      <Container small>
        <div className="EmployeesAll__jumplist">
          <label htmlFor="employees-jumplist">{i18next.t('employees_quickjump')}</label>
          <Select
            id="employees-jumplist"
            value=""
            handleChange={(data) => {
              window.location.hash = data.value;
            }}
            options={departmentsJumplist}
          />
        </div>
        {
          employees.keySeq().map((department, key) => {
            const values = employees.get(department).valueSeq().map((employee, index) => {
              const id = employee.getIn(['nid', '0', 'value']);
              const uuid = employee.getIn(['uuid', 0, 'value']);
              const langcode = employee.getIn(['langcode', 0, 'value']);
              const className = 'col col-6 col-sm-4';

              return (
                <div key={`${uuid}:${langcode}`} className={className}>
                  <Node
                    id={id}
                    key={`${uuid}:${langcode}`}
                    isActivePath
                    entity={employee}
                    viewMode="teaser"
                  />
                </div>
              );
            });

            return (
              <div key={department} className="EmployeesAll__department__wrapper">
                <Department id={department} entity={departments.get(department)} />
                <div className="row">
                  {values}
                </div>
              </div>
            );
          })
        }
      </Container>
    </div>
  );
};

export default EmployeesAll;
